import React from 'react';
import AboutUs from '../sectionBlocks/AboutSection';
import Award from '../sectionBlocks/Awards';
import RoadMap from '../sectionBlocks/RoadMapSection';
import Footer from '../sectionBlocks/Footer';

const About = () => {
  return (
    <>
      {/*<HeroSection1/>*/}
      <AboutUs/>
      <RoadMap/>
      <Award/>
      {/*<Gallery/>*/}
      <Footer/>
    </>
  );
};

export default About;